import { useQuery } from '@tanstack/react-query';
import { authorizedGet } from '../../../Config/networkWithToken';
import { config } from '../../../utils/helper';
import configuration from '../../../Config/configuration';

export const USERS_QUERY_KEY = ['matrimonyUsers'];

const fetchAllUsers = async () => {
  const res = await authorizedGet(configuration.apis.filter + "", config);
  const response = res?.data;
  if (!response?.status) throw new Error('Failed to fetch users');
  return response?.data ?? [];
};

export const useMatrimonyUsers = () => {
  return useQuery({
    queryKey: USERS_QUERY_KEY,
    queryFn: fetchAllUsers,
    staleTime: 5 * 60 * 1000,   
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,       
  });
};